const locations = [
  {
    id: "1",
    name: "Narok",
    image: require("../assets/image/narok_joujo_travel_africa.jpg"),
    rating: "5",
    desc: "Gateway to the world-famous Maasai Mara, Narok is rich in Maasai culture and tradition. Explore the vibrant local markets, meet Maasai communities, and embark on game drives where you can witness the Great Wildebeest Migration, the Big Five, and sweeping savannah landscapes."
  },
  {
    id: "2",
    name: "Naivasha",
    image: require("../assets/image/naivasha_trip_couple_kenya.png"),
    rating: "5",
    desc: "Naivasha is a tranquil escape known for Lake Naivasha, Crescent Island, and Hell’s Gate National Park. Enjoy boat rides with hippo sightings, nature walks among giraffes and zebras, and thrilling rock climbing or biking adventures through dramatic gorges."
  },
  {
    id: "3",
    name: "Amboseli",
    image: require("../assets/image/6.jpg"),
    rating: "4",
    desc: "Amboseli is famous for its large elephant herds and stunning views of Mount Kilimanjaro. Experience unforgettable safari drives, authentic Maasai village visits, and unique photography opportunities with wildlife silhouetted against Africa’s highest peak."
  },
  {
    id: "4",
    name: "Samburu",
    image: require("../assets/image/4.jpg"),
    rating: "5",
    desc: "Samburu offers a unique safari experience with rare wildlife such as Grevy’s zebra, reticulated giraffe, and the Somali ostrich. The arid, rugged landscape is home to the Samburu people, known for their colorful attire and rich cultural heritage."
  },
  {
    id: "5",
    name: "Nanyuki",
    image: require("../assets/image/nairobi_safari_experience.jpg"),
    rating: "4",
    desc: "Nestled at the base of Mount Kenya, Nanyuki blends adventure and relaxation. Visit the Ol Pejeta Conservancy to see rhinos, chimpanzees, and big cats, or cross the equator line. The area also offers scenic hikes and luxury lodges."
  },
  {
    id: "6",
    name: "Nairobi",
    image: require("../assets/image/nanyuki_air_travel.jpg"),
    rating: "4",
    desc: "Kenya’s vibrant capital offers a mix of urban life and wildlife. Visit the Nairobi National Park, Giraffe Centre, and David Sheldrick Elephant Orphanage. Explore local cuisine, museums, and the bustling Maasai Market for a taste of Kenya’s diverse culture."
  },
  {
    id: "7",
    name: "Kisumu",
    image: require("../assets/image/kisumu_time_travel_safari_lakeside.jpg"),
    rating: "4",
    desc: "Located along Lake Victoria, Kisumu is a laid-back lakeside city known for fishing, birdwatching, and stunning sunsets. Visit Dunga Hill Camp, the Kisumu Impala Sanctuary, and learn about Luo culture through local cuisine and museums."
  },
  {
    id: "8",
    name: "Embu",
    image: require("../assets/image/embu_kenya_town.jpg"),
    rating: "4",
    desc: "Tucked in the foothills of Mount Kenya, Embu is a gateway to scenic hikes, waterfalls, and tea plantations. Explore the serene countryside, enjoy authentic local dishes, and connect with vibrant agricultural communities."
  },
  {
    id: "9",
    name: "Diani",
    image: require("../assets/image/diani_summertides_kenya_coast.jpg"),
    rating: "4",
    desc: "Diani Beach is one of Africa’s most stunning coastal destinations. With white sands, turquoise waters, and swaying palms, it’s perfect for relaxation or water sports like snorkeling, diving, and kitesurfing. Don’t miss the coral reefs and nearby Shimba Hills."
  },
  {
    id: "10",
    name: "Malindi",
    image: require("../assets/image/malindi_beach_coastal.jpg"),
    rating: "4",
    desc: "A melting pot of cultures, Malindi boasts historic Swahili architecture, golden beaches, and coral gardens. Explore the Gedi Ruins, go deep-sea fishing, or relax by the ocean. The Vasco da Gama Pillar and marine parks are top attractions."
  },
  {
    id: "11",
    name: "Eldoret",
    image: require("../assets/image/eldoret_town_in_kenya.jpg"),
    rating: "4",
    desc: "Set in the scenic highlands, Eldoret is Kenya’s running capital and agricultural powerhouse. Visit the nearby Kerio Valley, enjoy local cuisine, or tour training camps that have produced world-class marathoners. Ideal for nature lovers and fitness enthusiasts."
  },
  {
    id: "12",
    name: "Mombasa",
    image: require("../assets/image/mombasa_expendition_safari_explore.jpg"),
    rating: "4",
    desc: "Mombasa is a historic port city that blends African, Arab, and European influences. Discover Old Town’s architecture, Fort Jesus, spice markets, and stunning beaches like Nyali and Bamburi. Enjoy vibrant nightlife, Swahili cuisine, and coastal culture."
  },
  {
    id: "13",
    name: "Voi",
    image: require("../assets/image/voi_kenya_coast.jpg"),
    rating: "4",
    desc: "Voi serves as the gateway to Tsavo East National Park, one of Kenya’s largest and oldest parks. Expect close encounters with elephants, lions, and hippos. The landscape features rocky outcrops, red soil, and vast wilderness for pure safari magic."
  },
  {
    id: "14",
    name: "Kilifi",
    image: require("../assets/image/kilifi_watamu_coast.jpg"),
    rating: "4",
    desc: "A hidden gem on the Kenyan coast, Kilifi offers a mix of beach life and history. Relax at Bofa Beach, explore the Mnarani ruins, or enjoy sailing on Kilifi Creek. It’s quieter than Mombasa and ideal for romantic or peaceful getaways."
  },
  {
    id: "15",
    name: "Tsavo",
    image: require("../assets/image/tsavo_east_tsavo_west_tours.jpg"),
    rating: "4",
    desc: "Tsavo is divided into East and West parks, each offering distinct landscapes and wildlife. Explore lava flows, Mzima Springs, and massive herds of red-dusted elephants. It’s raw, wild, and ideal for deep safari experiences away from crowds."
  }
];

export default locations;
